// Form5 Types - Generic list management form

export interface Section {
  id: string;
  pageComponentId: string;
  componentId?: string;
  type: string;
  variant: string;
  title: string;
  order: number;
  data?: any;
}

export interface VariantDetails {
  id: string;
  name: string;
  description: string;
  componentFields: any[];
  metadataFields?: any[];
  showTable: boolean;
  setAction: any;
  selector: (state: any) => any;
  createMethod?: (data: any) => Promise<any>;
  updateMethod?: (id: number, data: any) => Promise<any>;
  fetchMethod?: (id: number) => Promise<any>;
  deleteMethod?: (id: number) => Promise<any>;
  TREE_CONFIG?: TreeConfig;
  constants: Record<string, string>;
}

export interface TreeConfig {
  treeIcon?: string;
  treeTitle?: string;
  emptyMessage?: string;
  itemDisplayFields?: {
    primary?: string;
    secondary?: string;
  };
  formLabels?: {
    newButton?: string;
    edit?: string;
    addNew?: string;
    updateButton?: string;
    saveButton?: string;
    cancelButton?: string;
  };
  deleteConfirmation?: (item: ListItem) => string;
}

export interface ListItem {
  id?: number | string;
  university_settings_id?: number;
  [key: string]: any;
}

export interface FormProps {
  selectedSection: Section;
  onSave: (updatedSection: Section) => void;
  pageId?: string;
  pageComponentId?: string;
  variantDetails?: VariantDetails;
}

export interface ListState {
  items: ListItem[];
  editingItemId: string | null;
}

export interface FormState {
  componentFields: Record<string, any>;
  componentFieldErrors: Record<string, boolean>;
  componentFieldMessages: Record<string, string>;
}

